import SolicitationService from "../../services/SolicitationService/SolicitationService";

export interface PrefState {
    data?: any,
    dataLocal?: any,
    prefUserId?: number,
    timeKeepWork?: boolean,
    openedModalWork?: boolean,
    solicitationTypeDash?: string,
    businessAreaDash?: number,
    competenceDash?: string,
    promptShow?: boolean,
    promptStatus?: boolean,
    promptPath?: string
    attendantSolicitationList?: any
}

type Action = { type: string, payload: any }

export const prefReducer = (state: PrefState = {}, action: Action) => {
    const solicitationService = new SolicitationService({});

    const savePrefs = async (data_: any) => {
        try {
            const data = {
                IdUser: Number(state.prefUserId),
                Json: JSON.stringify(data_)
            }

            await solicitationService.SavePref(data);
        }
        catch (error) {
            debugger
        }
    }

    switch (action.type) {
        case 'PREF_LOAD': return { ...state, data: action.payload };
        case 'PREF_UPDATE':
            const { name, value } = action.payload;

            let _data = state.data || {};
            _data[name] = value;

            savePrefs(_data);

            return { ...state, data: _data };
        case 'PREF_UPDATE_MORE':
            let data_ = state.data || {};
            data_ = { ...state.data, ...action.payload };

            savePrefs(data_);

            return { ...state, data: data_ };
        case 'PREF_UPDATE_LOCAL':
            let _data_local = state.dataLocal || {};
            _data_local[action.payload.name] = action.payload.value;

            return { ...state, dataLocal: _data_local };
        case 'PREF_UPDATE_MORE_LOCAL':
            let data_local = state.dataLocal || {};
            data_local = { ...state.dataLocal, ...action.payload };

            return { ...state, dataLocal: data_local };
        case 'PREF_USER_ID': return { ...state, prefUserId: action.payload };
        case 'PREF_TIMEKEEP_WORK': return { ...state, timeKeepWork: action.payload };
        case 'PREF_OPENED_MODAL_WORK': return { ...state, openedModalWork: action.payload };
        case 'PREF_SOLICITATIONTYPE_DASH': return { ...state, solicitationTypeDash: action.payload };
        case 'PREF_BUSINESSAREA_DASH': return { ...state, businessAreaDash: action.payload };
        case 'PREF_COMPETENCE_DASH': return { ...state, competenceDash: action.payload };
        case 'PREF_PROMPT_SHOW': return { ...state, promptShow: action.payload };
        case 'PREF_PROMPT_STATUS': return { ...state, promptStatus: action.payload };
        case 'PREF_PROMPT_PATH': return { ...state, promptPath: action.payload };
        case 'PREF_ATTENDANT_SOLICITATIONLIST': return { ...state, attendantSolicitationList: action.payload };
        default: return state;
    }
}